// frontend/src/pages/SoftwareBlocking/SoftwareBlocking.js
import React from "react";
import { Container, Row, Col } from "reactstrap";
import FeatherIcon from "feather-icons-react";
//import SoftwareBlockingTiles from "./SoftwareBlockingTiles";
import SoftwareBlockingForm from "./SoftwareBlockingForm";

const SoftwareBlocking = () => {
  document.title = "Software Blocking - RiskNoX";

  const headingIconChip = {
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(255, 91, 0, 0.12)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Page Header */}
          <div className="page-title-box d-flex align-items-center justify-content-between mb-4">
            <div>
              <h4 className="mb-1 fw-bold">
                <span style={headingIconChip} className="me-2">
                <FeatherIcon icon="shield" size={18} className="text-danger" />
                </span>
                Application Security Control
              </h4>
              <p className="text-body-secondary mb-0">
                Manage and monitor blocked applications across your network
              </p>
            </div>
          </div>

          {/* Info Banner */}
         {/* <Card
            className="border-0 shadow-sm mb-4"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            }}
          >
            <CardBody className="py-3">
              <Row className="align-items-center">
                <Col md={8}>
                  <div className="d-flex align-items-center text-white">
                    <FeatherIcon icon="info" size={20} className="me-3" />
                    <div>
                      <h6 className="mb-0 text-white fw-bold">
                        Application Blocking Status
                      </h6>
                      <small className="text-white-50">
                        Block applications from running on managed endpoints •
                        Real-time enforcement
                      </small>
                    </div>
                  </div>
                </Col>

                
                <Col md={4} className="text-md-end mt-3 mt-md-0">
                  <div className="d-flex align-items-center justify-content-md-end text-white">
                    <div
                      className="rounded-circle me-2"
                      style={{
                        width: "10px",
                        height: "10px",
                        background: "rgba(255, 255, 255, 0.35)", // adaptive & softer in dark mode
                      }}
                    ></div>
                    <small className="fw-medium">System Active</small>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          
          <SoftwareBlockingTiles />*/}

          {/* Main Content */}
          <Row className="mt-4">
            <Col xs={12}>
              <SoftwareBlockingForm />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SoftwareBlocking;
